export default {"src":"/_next/static/media/gallery.d51f8b83.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};